<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("shift", 2) }}
      </div>
      <router-link class="btn-blue" to="shifts"
        >{{ $tc("shift", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Shifts"
          :key="index"
          v-if="item.fieldname !== 'shift_id'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div
            v-if="
              (item.type !== 'radio') &
              (item.type !== 'time') &
              (item.fieldname != 'shift_working_hrs')
            "
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p
              v-if="submitted && errors.has(item.fieldname)"
              class="error_message"
            >
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>
          <div>
            <label v-if="item.fieldname == 'shift_working_hrs'"
              >Working Hours : {{ item.fieldvalue }}</label
            >
          </div>

          <div v-if="item.type === 'radio'" class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $tc(item.placeholder, 1) }}</label>
            <b-form-checkbox
              type="checkbox"
              class="j-checkbox mb-0 ml-2"
              v-model="item.fieldvalue"
            />
          </div>

          <div
            v-if="item.fieldname == 'shift_start_time'"
            class="custom-timepicker"
          >
            <vue-timepicker
              manual-input
              v-model="shift_start_time"
              name="shift_start_time"
              id="shift_start_time"
              format="HH:mm"
              placeholder="Start Time"
              class="time_picker w-91"
              input-width="100%"
              auto-scroll
              lazy
              @change="onChangeShowTime($event, 'start')"
              v-validate="'required'"
            ></vue-timepicker>
            <!-- <date-picker
              v-model="item.fieldvalue"
              @change="onChangeShowTime($event,'start')"
              lang="en"
              type="time"
              format="hh:mm a"
              :minute-step="1"
              class="time_picker w-91"
              placeholder="Start Time"
              @input="onclose($event)"
              name="shift_start_time"
              id="shift_start_time"
              v-validate="'required'"
            ></date-picker> -->

            <p
              v-if="submitted && errors.has(item.fieldname)"
              class="error_message"
            >
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>

          <div
            v-if="item.fieldname == 'shift_end_time'"
            class="custom-timepicker"
          >
            <vue-timepicker
              manual-input
              v-model="shift_end_time"
              name="shift_end_time"
              id="shift_end_time"
              format="HH:mm"
              placeholder="End Time"
              class="time_picker w-91"
              input-width="100%"
              auto-scroll
              lazy
              @change="onChangeShowTime($event, 'end')"
              v-validate="'required'"
            ></vue-timepicker>
            <!-- <date-picker
              v-model="item.fieldvalue"
              @change="onChangeShowTime($event,'end')"
              lang="en"
              type="time"
              format="hh:mm a"
              :minute-step="1"
              class="time_picker w-91"
              placeholder="End Time"
              name="shift_end_time"
              id="shift_end_time"
              v-validate="'required'"
            ></date-picker> -->
            <p
              v-if="submitted && errors.has(item.fieldname)"
              class="error_message"
            >
              {{ errors.first(`${item.fieldname}`) }}
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="shifts">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Shifts from "@/helper/formJSONMaster/Shifts";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      btenable: false,
      disabledDates: {
        to: new Date(2019, 9, 26),
      },
      Shifts: Shifts.ms_shifts,
      // v-validate="'required|email'"
      submitted: false,
      Methods: Shifts.Methods,
      st: "",
      et: "",
      shift_start_time: "",
      shift_end_time: "",
    };
  },
  mounted() {
    console.log("Shifts :", Shifts);
    this.resetHandler();
  },
  methods: {
    onChangeTimePicker: function (date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      // this.st = strTime;
      return strTime;
      // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
    },
    // onChangeEndTimePicker: function(date) {
    //   var hours = date.getHours();
    //   var minutes = date.getMinutes();
    //   var ampm = hours >= 12 ? "PM" : "AM";
    //   hours = hours % 12;
    //   hours = hours ? hours : 12; // the hour '0' should be '12'
    //   minutes = minutes < 10 ? "0" + minutes : minutes;
    //   var strTime = hours + ":" + minutes + " " + ampm;
    //   this.et = strTime;
    //   return strTime;
    //   // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
    // },
    // convertToTime: function(value, value1) {
    //     let end_time = moment(this.movieSelected.selected_time).add(parseInt(this.movieSelected.lengthMinutes), "m").toDate();
    //     this.movieSelected.end_time = moment(end_time).format("hh:mm A");
    // },

    onclose: function (e) {},
    onChangeShowTime: function (event, type) {
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      console.log("event", event);
      if (type == "start") {
        // console.log("moment(event)", moment(event).format("hh:mm A"));
        Shifts.ms_shifts[2].fieldvalue = event;
        this.$forceUpdate();
        // console.log("shiftt start time ", Shifts.ms_shifts[3].fieldvalue);

        this.st = this.onChangeTimePicker(Shifts.ms_shifts[2].fieldvalue);
        console.log("this.st :", this.st);
      }
      if (type == "end") {
        Shifts.ms_shifts[3].fieldvalue = event;
        this.$forceUpdate();

        this.et = this.onChangeTimePicker(Shifts.ms_shifts[3].fieldvalue);
      }
      console.log("this.st,this.et :", this.st, this.et);
      if (this.st && this.st.length > 0 && this.et && this.et.length > 0) {
        var startTime = moment(`${this.st}`, "hh:mm a");
        var endTime = moment(`${this.et}`, "hh:mm a");
        this.Shifts.map((x, index) => {
          if (x.fieldname === "shift_working_hrs") {
            if (
              (moment(startTime, "hh:mm a").format("A") ==
                moment(endTime, "hh:mm a").format("A") &&
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    startTime.format("hh:mm a")
                ).format() >=
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      endTime.format("hh:mm a")
                  ).format()) ||
              (moment(startTime, "hh:mm a").format("A") == "PM" &&
                moment(endTime, "hh:mm a").format("A") == "AM")
            ) {
              this.Shifts[index].fieldvalue =
                24 + endTime.diff(startTime, "hours");
            } else {
              this.Shifts[index].fieldvalue = endTime.diff(startTime, "hours");
            }
          }
        });
      }
    },
    // onChangeShowEndTime: function(event) {
    //   if(type == 'end')
    //   {Shifts.ms_shifts[4].fieldvalue = event;
    //   this.$forceUpdate();

    //   this.et = this.onChangeTimePicker(Shifts.ms_shifts[4].fieldvalue);}
    //   if (this.st && this.st.length > 0  && this.et && this.et.length > 0) {
    //     var startTime = moment(`${this.st}`, "hh:mm a");
    //     var endTime = moment(`${this.et}`, "hh:mm a");
    //     this.Shifts.map((x, index) => {
    //       if (x.fieldname === "shift_working_hrs") {
    //         this.Shifts[index].fieldvalue = endTime.diff(startTime, "hours");
    //       }
    //     });

    //   }

    // },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    resetHandler: function () {
      this.Shifts.map((x) => {
        if (x.type === "text" || x.type === "date" || x.type === "time") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
      $("#shift_start_time").val("");
      $("#shift_end_time").val("");
    },
    handleSubmit(flag) {
      console.log("this.Shifts :", this.Shifts);
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody("POST", this.Shifts, this.Methods);
          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.resetHandler();
                if (flag) {
                  this.$router.push({
                    path: "/cinema-manager/shifts",
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftsComponents/addShift.vue